import {
    GET_IMAGES,
    CAI_LOADING,
    CAI_LOADING2,
    ADD_IMAGE
  } from "../actions/ExtracurricularCoursesAdminImageAction";
  
  
  const initialState = {
    imagelist: [],
    loading: false,
    loading2: false,
    add: false,
  };
  
  const UserAdmin = function(state = initialState, action) {
    switch (action.type) {
        case CAI_LOADING: {
          return {
            ...state,
            loading: true,
            add: false
          };
        }
        case CAI_LOADING2: {
          return {
            ...state,
            loading2: true,
            add: false
          };
        }
        case GET_IMAGES: {
          return{
              ...state,
              imagelist : [...action.data],
              loading: false,
              loading2: false
          }
        }
        case ADD_IMAGE: {
          return {
            ...state,
            add : true,
            loading: false,  
            loading2: false  
          };
        }
        default: {
            return state;
          }
        }
  }
  
  export default UserAdmin;
  